import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { capitalizeFirstLetter } from 'utilities/stringUtils'
import { decimalDisplay } from 'utilities/pricing'
import OrderSummaryTotal from 'components/OrderSummaryTotal'
import OrderSummaryItem from 'components/OrderSummaryItem'
import OrderSummaryItemLarge from 'components/OrderSummaryItemLarge'
import { calculateUpfront } from 'containers/stages/PaymentStage/utils'

import { OWNER_OF_SERVICE, NOT_OWNER_OF_SERVICE } from './constants'
import styles from './styles.scss'

class OrderSummaryPaymentScreen extends PureComponent {
  static propTypes = {
    installAddress: PropTypes.array,
    planSelected: PropTypes.shape({
      id: PropTypes.string,
      interval: PropTypes.string,
      limit: PropTypes.string,
      marketingTagline: PropTypes.string,
      rate: PropTypes.number,
      title: PropTypes.string,
      orderSummaryDisclaimer: PropTypes.string,
      planColor: PropTypes.string,
    }),
    deliveryAddress: PropTypes.string,
    ownsService: PropTypes.bool,
    detailsProvided: PropTypes.object,
    stageSettings: PropTypes.object,
    summarySettings: PropTypes.object,
    email: PropTypes.string,
    modemRequired: PropTypes.bool,
    totalUpfront: PropTypes.number,
  }

  static defaultProps = {
    installAddress: [],
    planSelected: {},
    deliveryAddress: {},
    detailsProvided: {},
    stageSettings: {},
    summarySettings: {},
    ownsService: false,
    email: '',
    modemRequired: false,
    totalUpfront: null,
  }

  render() {
    const {
      installAddress,
      planSelected,
      deliveryAddress,
      detailsProvided,
      stageSettings,
      summarySettings,
      ownsService,
      modemRequired,
      email,
      totalUpfront,
    } = this.props

    const {
      costHeading,
      costText,
      planInfoText,
      modemInfoText,
    } = summarySettings

    const planRate = decimalDisplay(planSelected.rate)
    const totalDisplay = decimalDisplay(totalUpfront)

    const installAddressStreet = installAddress.length >= 1 ? `${installAddress[0]},` : null
    const installAddressCity = installAddress.length >= 2 ? installAddress[1] : null

    const firstName = `${capitalizeFirstLetter(this.props.detailsProvided.first_name)}`
    const middleName = ` ${capitalizeFirstLetter(this.props.detailsProvided.middle_name)}`
    const lastName = ` ${capitalizeFirstLetter(this.props.detailsProvided.last_name)}`

    const ownServiceIcon = ownsService ? <i className="kgnIcon kgn-icon-checkmark" /> : null
    const ownServiceText = ownsService ? OWNER_OF_SERVICE : NOT_OWNER_OF_SERVICE
    const ownServiceClass = ownsService ? styles.ownsService : ''
    const deliveryAddressSplit = deliveryAddress.split(',')

    const disclaimers = planSelected.orderSummaryDisclaimer ? (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: planSelected.orderSummaryDisclaimer }}
      />
    ) : null

    return (
      <div className={styles.orderSummaryPayment}>
        <OrderSummaryTotal
          title={costHeading}
          headingClass={styles.heading}
          primaryInfo={costText}
          planRate={planRate}
          planUpfront={totalDisplay}
          planInterval={planSelected.interval}
          extraClass={styles.orderTotal}
        >
          <OrderSummaryItemLarge
            icon="plan"
            iconColor={planSelected.planColor}
            title={planSelected.title}
            subtitle={planSelected.marketingTagline}
            primaryInfo={`$${planRate}`}
            secondaryInfo={planInfoText}
            extraClass={styles.summaryItemLarge}
          >
            {disclaimers}
          </OrderSummaryItemLarge>
          { modemRequired ?
            <OrderSummaryItemLarge
              secondaryInfo={modemInfoText}
              extraClass={styles.summaryItemLarge}
            /> : null
          }
        </OrderSummaryTotal>
        <OrderSummaryItem
          icon="house"
          title={stageSettings.landline_check}
          primaryInfo={installAddressStreet}
          secondaryInfo={installAddressCity}
          extraClass={styles.summaryItem}
        >
          {ownsService !== null &&
            <div className={`${styles.ownServiceBase} ${ownServiceClass}`}>
              {ownServiceIcon}
              {ownServiceText}
            </div>
          }
        </OrderSummaryItem>
        { modemRequired &&
          <OrderSummaryItem
            icon="truck"
            title={stageSettings.modem_delivery}
            primaryInfo={deliveryAddressSplit[0]}
            secondaryInfo={deliveryAddressSplit[1]}
            extraClass={styles.summaryItem}
          />
        }
        <OrderSummaryItem
          icon="person"
          title={stageSettings.personal}
          primaryInfo={`${firstName}${middleName}${lastName}`}
          extraClass={styles.summaryItem}
        >
          <div className={styles.expandedDisplay}>
            <div className={styles.extraInfo}>{email}</div>
            <div className={styles.extraInfo}>{detailsProvided.phone}</div>
          </div>
        </OrderSummaryItem>
        <OrderSummaryItem
          icon="identification"
          title="Identification"
          primaryInfo="Identity Verified" // MAKE UTIL
          extraClass={styles.summaryItem}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    installAddress: state.checkoutReducer.installAddress,
    deliveryAddress: state.checkoutReducer.modemDeliveryAddress,
    detailsProvided: state.checkoutReducer.personalFieldValues,
    planSelected: state.checkoutReducer.planSelected,
    email: state.checkoutReducer.email,
    modemRequired: state.checkoutReducer.modemRequired,
    ownsService: state.checkoutReducer.ownsService,
    totalUpfront: calculateUpfront(state),
  }
}

export default connect(mapStateToProps)(OrderSummaryPaymentScreen)



// WEBPACK FOOTER //
// ./components/OrderSummaryPaymentScreen/index.jsx